<template>
  <div>
    <div class="form-group mb-3">
      <label>Projekcija</label>
      <select
        id="projection"
        name="projection_id"
        class="form-control"
        v-model="parentProjection"
        @change="filterCategories"
      >
        <option></option>
        <option
          v-for="(projection, idx) in projections"
          :key="idx"
          :value="projection.id"
        >
          {{ projection.name }}
        </option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label>Kategorija</label>
      <select
        id="category"
        name="category_id"
        class="form-control"
        :disabled="!parentProjection"
        v-model="parentCategory"
        @change="getSubCategories"
      >
        <option></option>
        <option
          v-for="(category, idx) in projectionCategories"
          :key="idx"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label>Podkategorija</label>
      <select
        id="subcategory"
        name="sub_category_id"
        class="form-control"
        :disabled="!parentCategory"
        v-model="subCategory"
      >
        <option
          v-for="(category, idx) in subcategories"
          :key="idx"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: [
    "projections",
    "categories",
    "route_path",
    "projection",
    "category",
    "subcategory",
  ],
  data() {
    return {
      subcategories: [],
      parentProjection: null,
      parentCategory: null,
      subCategory: null,
    };
  },
  computed: {
    projectionCategories() {
      console.log(this.parentProjection);
      return this.categories.filter(
        (item) => item.projection_id === this.parentProjection
      );
    }
  },
  methods: {
    getSubCategories() {
      if (!this.parentCategory) {
        this.sucategories = [];
        this.subCategory = null;
      } else {
        axios
          .get(this.route_path, {
            params: {
              category_id: this.parentCategory,
            },
            accept: "application/json",
          })
          .then((res) => {
            console.log(res);
            this.subcategories = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    filterCategories() {      
      if (!this.parentProjection) {
        this.category = null;
        this.subCategory = null;
        this.parentCategory = null;
        this.subcategories = [];
        return [];
      }
      
    },
  },
  created() {
    if(this.projection){
      this.parentProjection = this.projection;
      this.filterCategories();
    }
    if (this.category) {
      this.parentCategory = this.category;
      this.getSubCategories();
      this.subCategory = this.subcategory;
    }
  },
};
</script>

<style>
</style>